<template>
    <div style="margin-top:0px;">
        <v-row class="justify-center">
            <v-col cols="10" md="6">
                <v-btn block color="black" dark to="/practice">
                    PRACTICAR
                </v-btn>
            </v-col>
        </v-row>
        <v-row class="justify-center">
            <v-col cols="10" md="6">
                <v-btn block color="black" dark to="/free">
                    LIBRE
                </v-btn>
            </v-col>
        </v-row>
        <v-row class="justify-center">
            <v-col cols="10" md="6">
                <v-btn block color="black" dark to="/easy">
                    EASY MODE (10 seg)
                </v-btn>
            </v-col>
        </v-row>
        <v-row class="justify-center">
            <v-col cols="10" md="6">
                <v-btn block color="black" dark to="/hard">
                    HARD MODE (5 seg)
                </v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
  export default {
    name: 'Menu',

    data: () => ({
        
    }),
}
</script>
